import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './style.css';
import authService from '../../services/authService';
import { toast } from "react-toastify";

export default class MobileMenu extends Component {

    handleLogout = () => {
        try {
            const result = authService.logout();
            if (result.success) {
                toast.success(result.message);
                window.location.href = "/"; // Redirect after logout
            }
        } catch (error) {
            toast.error(error.message);
        }
    }

    state = {
        isMenuShow: false,
        isOpen: 0,
    }

    menuHandler = () => {
        this.setState({
            isMenuShow: !this.state.isMenuShow
        })
    }

    render() {
        const { isMenuShow } = this.state;
        const isLoggedIn = sessionStorage.getItem('isLoggedIn') === "true";

        const ClickHandler = () => {
            window.scrollTo(10, 0);
        }

        return (
            <div>
                <div className={`mobileMenu ${isMenuShow ? 'show' : ''}`}>
                    <ul className="responsivemenu">
                        <li>
                            <Link to="/home" onClick={ClickHandler}>Home</Link>
                        </li>
                        <li>
                            <Link to="/rules" onClick={ClickHandler}>Rules</Link>
                        </li>
                        <li>
                            <Link to="/events-offers" onClick={ClickHandler}>Events</Link>
                        </li>
                        <li>
                            <Link to="/contact" onClick={ClickHandler}>Contact Us</Link>
                        </li>
                        {/* Conditionally render based on login status */}
                        {!isLoggedIn ? (
                            <>
                                <li>
                                    <Link to="/login" onClick={ClickHandler}>Login</Link>
                                </li>
                                <li>
                                    <Link to="/signup" onClick={ClickHandler}>Signup</Link>
                                </li>
                            </>
                        ) : (
                            <>
                                <li>
                                    <Link to="/profile" onClick={ClickHandler}>Profile</Link>
                                </li>
                                <li>
                                    <Link to="/wallet/transactions" onClick={ClickHandler}>Wallet</Link>
                                </li>
                                <li>
                                    <Link to="/bookings/history" onClick={ClickHandler}>Bookings</Link>
                                </li>
                                <li>
                                    <Link to="/bank/details" onClick={ClickHandler}>Withdrawal</Link>
                                </li>
                                <li>
                                    <Link to="" onClick={this.handleLogout}>Logout</Link>
                                </li>
                            </>
                        )}
                    </ul>
                </div>

                <div className="showmenu" onClick={this.menuHandler}>
                    <i className="fa fa-bars" aria-hidden="true"></i>
                </div>
            </div>
        )
    }
}
